import { PopupTypeEnum } from '../enums/popupTypeEnum';

export const convertPopupTypeToString = (value: PopupTypeEnum): string => {
  switch (value) {
    case PopupTypeEnum.LANDING_PAGE:
      return 'Landing Page';
    case PopupTypeEnum.DELIVERY:
      return 'Delivery';
    // case PopupTypeEnum.COUPON:
    //   return 'Coupon';
    // case PopupTypeEnum.PROMOTION:
    //   return 'Promotion';
    // case PopupTypeEnum.CATEGORY:
    //   return 'Category';
    // case PopupTypeEnum.PRODUCT:
    //   return 'Product';
    // case PopupTypeEnum.MERCHANT:
    //   return 'Merchant';
    default:
      return '';
  }
};
